/**
 * Dropdown catalogs used by the order, note, report and filter screens.
 *
 * The lists come from SUCURSAL_OPTIONS / LOT_OPTIONS / LOT_AUTHORITY_OPTIONS in the
 * repo-root .env, which dotenv-webpack inlines at build time (see
 * frontend/vue.config.js). Adding an option means editing .env and rebuilding the
 * frontend.
 *
 * The DEFAULT_* lists below are a fallback for when the variables are missing, so
 * a misconfigured build degrades to the previous hardcoded catalog instead of
 * rendering empty dropdowns.
 */

const DEFAULT_SUCURSAL_OPTIONS = [
  'ASISTENCIA AUXILIO VIAL',
  'ASISTENCIA AUXILIO VIAL FORANEAS',
  'ASISTENCIAS FORANEAS',
  'ASISTENCIAS',
  'ASISTENCIAS PARTICULAR',
  'CANCELADOS',
  'CONTADO',
  'FILIALES',
  'FORANEOS',
  'REVOLUCION',
  'LOTE SALTILLO',
  'LOTE SANTA ROSA',
  'LOTE CHINA',
  'LOTE GUADALUPE',
  'LOTE GUADALUPE FEDERAL',
  'LOTE SANTA CATARINA',
  'LOTE SAN ROBERTO',
  'REFACTURACION',
  'REMOLQUE',
  'SAN RAFAEL',
  'PARA EFECTOS DE COMISION',
];

const DEFAULT_LOT_OPTIONS = [
  'LOTE SANTA CATARINA',
  'LOTE SAN ROBERTO',
  'LOTE SAN RAFAEL',
  'LOTE CHINA',
  'RESGUARDO',
];

const DEFAULT_LOT_AUTHORITY_OPTIONS = [
  'A DISP. CITU',
  'A DISP. MINISTERIO PUBLICO',
  'A DISP. PRESID. MPAL.',
  'EMBARGO',
  'INSPEC.S.C.T.',
  'NO ENCONTRADOS',
  'P.G.R.',
  'P.G.R. SALTILLO',
  'PARTICULAR',
  'PENDIENTES DE REVISAR',
  'POLICIA JUDICIAL',
  'POLICIA MPAL. GPE.',
  'Prueba',
  'REMATE',
  'REMATE DIC. 96',
  "REMATE ABRIL'96",
  "REMATE '97",
  'TRANSITO ALDAMAS',
  'TRANSITO CADEREYTA',
  'TRANSITO CHINA',
  'TRANSITO FEDERAL',
  'TRANSITO FEDERAL (CHATARRA)',
  'TRANSITO GENERAL BRAVO',
  'TRANSITO GUADALUPE',
  'TRANSITO LOS HERRERA',
  'TRANSITO MONTERREY',
  'TRANSITO PESQUERIA',
  'TRANSITO RAMOS ARIZPE',
  'TRANSITO SAN NICOLAS',
  'TRANSITO SANTIAGO',
  'TRANSITO STA CATARINA',
  'YA FACTURADOS/NO DEPOSITADOS',
];

function parseOptionList(raw, fallback) {
  if (typeof raw !== 'string') {
    return [...fallback];
  }
  const parsed = raw
    .split(',')
    .map((entry) => entry.trim())
    .filter(Boolean);
  const deduped = [...new Set(parsed)];
  return deduped.length ? deduped : [...fallback];
}

// dotenv-webpack substitutes these references literally, so each one has to be
// written out in full rather than looked up dynamically.
export const SUCURSAL_OPTIONS = parseOptionList(
  process.env.SUCURSAL_OPTIONS,
  DEFAULT_SUCURSAL_OPTIONS
);

export const LOT_OPTIONS = parseOptionList(process.env.LOT_OPTIONS, DEFAULT_LOT_OPTIONS);

export const LOT_AUTHORITY_OPTIONS = parseOptionList(
  process.env.LOT_AUTHORITY_OPTIONS,
  DEFAULT_LOT_AUTHORITY_OPTIONS
);

export default { SUCURSAL_OPTIONS, LOT_OPTIONS, LOT_AUTHORITY_OPTIONS };
